import React from "react";
import ComingSoon from "components/admin/ComingSoon";

const AdminDashboard: React.FC = () => (
  <ComingSoon
    icon="📊"
    title="대시보드"
    features={[
      "오늘 예약 · 이용 현황 요약 카드",
      "최근 예약 실시간 테이블",
      "인기 시설 TOP 5 차트",
      "미처리 문의 · 가입 요청 알림",
      "기간별 예약 추이 그래프",
    ]}
  />
);

export default AdminDashboard;
